/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout/Layout';

const layoutRouter = {
  path: '/user',
  component: Layout,
  redirect: 'procesos',
  meta: {
    title: 'Components',
    icon: 'component',
    requiresAuth: true
  },
  children: [
    {
      path: 'dashboard',
      component: () => import('@/views/Dashboard'),
      name: 'Dashboard',
      meta: {
        title: 'Dashboard',
        icon: 'mdi-view-dashboard-outline',
        affix: true,
        requiresAuth: true,
        roles: ['Administrador']
      }
    },
    {
      path: 'procesos',
      component: () => import('@/views/Procesos'),
      name: 'Procesos',
      meta: {
        title: 'Procesos',
        icon: 'mdi-timer-outline',
        affix: true,
        requiresAuth: true
      }
    },
    {
      path: 'adjudicados',
      component: () => import('@/views/Adjudicados'),
      name: 'Adjudicados',
      meta: {
        title: 'Adjudicados',
        icon: 'mdi-medal-outline',
        affix: true,
        requiresAuth: true
      }
    },
    {
      path: 'contratos',
      component: () => import('@/views/Contratos'),
      name: 'Contratos',
      meta: {
        title: 'Contratos',
        icon: 'mdi-calendar-range-outline',
        affix: true,
        requiresAuth: true
      }
    },
    {
      path: 'garantias-tecnicas',
      component: () => import('@/views/Garantias'),
      name: 'Garantías Técnicas',
      meta: {
        title: 'Garantías Técnicas',
        icon: 'mdi-shield-star-outline',
        affix: true,
        requiresAuth: true
      }
    },
    {
      path: 'archivo',
      component: () => import('@/views/Archivo'),
      name: 'Archivo',
      meta: {
        title: 'Archivo',
        icon: 'mdi-folder-multiple-outline',
        affix: true,
        requiresAuth: true
      }
    }
  ]
};

export default layoutRouter;
